import request from "@/utils/request"


/**
 * 获取字典类型分页列表
 * @param {*} data 
 * @returns 
 */
export function getDictTypePageListApi(data) {
  return request({
    url: "/Anno.Plugs.Rules/DictType/GetDictTypePageList",
    method: "post",
    data
  })
}

/**
 * 获取字典类型详情
 * @param {*} data 
 * @returns 
 */
export function getDictTypeApi(data) {
  return request({
    url: "/Anno.Plugs.Rules/DictType/GetDictType",
    method: "post",
    data
  })
}

/**
 * 新增字典类型
 * @param {*} data 
 * @returns 
 */
export function addDictTypeApi(data) {
  return request({
    url: "/Anno.Plugs.Rules/DictType/AddDictType",
    method: "post",
    data
  })
}

/**
 * 修改字典类型
 * @param {*} data 
 * @returns 
 */
export function updateDictTypeApi(data) {
  return request({
    url: "/Anno.Plugs.Rules/DictType/UpdateDictType",
    method: "post",
    data
  })
}


/**
 * 获取字典数据分页列表
 * @param {*} data 
 * @returns 
 */
export function getDictDataPageListApi(data) {
  return request({
    url: "/Anno.Plugs.Rules/DictData/GetDictDataPageList",
    method: "post",
    data
  })
}

/**
 * 根据字典类型获取字典数据（下拉用，仅返回正常状态）
 * @param {*} data 
 * @returns 
 */
export function getDictDataByTypeApi(data) {
  return request({
    url: "/Anno.Plugs.Rules/DictData/GetDictDataByType",
    method: "post",
    data
  })
}

/**
 * 获取字典数据详情
 * @param {*} data 
 * @returns 
 */
export function getDictDataApi(data) {
  return request({
    url: "/Anno.Plugs.Rules/DictData/GetDictData",
    method: "post",
    data
  })
}


/**
 * 新增字典数据
 * @param {*} data 
 * @returns 
 */
export function addDictDataApi(data) {
  return request({
    url: "/Anno.Plugs.Rules/DictData/AddDictData",
    method: "post",
    data
  })
}

/**
 * 修改字典数据
 * @param {*} data 
 * @returns 
 */
export function updateDictDataApi(data) {
  return request({
    url: "/Anno.Plugs.Rules/DictData/UpdateDictData",
    method: "post",
    data
  })
}